import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'Grandma Wura’s App ',
  description = 'Discover Grandma Wura’s App: interactive storytelling, cultural games, and educational content celebrating African heritage. Engaging and educational for all ages',
  tags,
}: {
  title: string;
  description?: string;
  tags?: string;
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={tags} />

      <meta property="og:type" content={'website'} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {/* <meta
        property="og:image"
        content=""
      /> */}

      {/* <meta name="twitter:site" content={"@GO54HQ"} /> */}
    </Helmet>
  );
}
